var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "setup-guide" },
    [
      _c("p", { staticClass: "guide-title" }, [
        _vm._v("How to complete setup in " + _vm._s(_vm.platformLabel)),
      ]),
      _vm._l(_vm.steps, function (step) {
        return _c("div", { key: step.number, staticClass: "guide-step" }, [
          _c("div", { staticClass: "guide-number" }, [
            _vm._v(_vm._s(step.number)),
          ]),
          _c("div", { staticClass: "guide-content" }, [
            _c("p", {
              staticClass: "guide-step-title",
              domProps: { innerHTML: _vm._s(step.title) },
            }),
            _c("p", { staticClass: "guide-step-desc" }, [
              _vm._v(_vm._s(step.description)),
            ]),
          ]),
        ])
      }),
      _vm.settingsImage
        ? _c("div", { staticClass: "guide-reference" }, [
            _c("p", { staticClass: "guide-reference-label" }, [
              _vm._v(
                "Reference — " +
                  _vm._s(_vm.platformLabel) +
                  " plugin settings page:"
              ),
            ]),
            _c("div", { staticClass: "guide-reference-image" }, [
              _c("img", {
                attrs: {
                  src: _vm.settingsImage,
                  alt: _vm.platformLabel + " plugin settings page",
                },
              }),
            ]),
          ])
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }